<template>
    <span>
        <span v-if="isInActive">
          <span :title="$t('site.status.inactiveWarningTip', [player.lastScoreChange])">
            <font-awesome-icon icon="exclamation-triangle" style="color:black;"></font-awesome-icon>
          </span>
        </span>
        <span v-if="isFriend">
            <span :title="$t('site.status.isFriendTip')">
              <font-awesome-icon icon="heart" style="color:darkred;"></font-awesome-icon>
            </span>
        </span>
    </span>
</template>


<script>
    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
    export default {
        name: 'elv-user-badges',
        components: {FontAwesomeIcon},
        props: {
            'player' : {required:true}
        },
        computed: {
          isInActive: {
            get: function() {
              //console.log("CHECKING IF PLAYER IS ACTIVE FOR BADGE RENDER", this.player.isActive !== true, this.player);
              return this.player.isActive !== true;
            }
          },
          isFriend: {
            get: function() {
              //console.log("CHECKING IF PLAYER IS friend FOR BADGE RENDER", this.player);
              return this.player.isFriend === true;
            }
          }
        },
        data () {
            return {
            }
        },
    }
</script>

<style scoped>
    .darkred {
        color: darkred;
    }
</style>



// WEBPACK FOOTER //
// src/components/ElvUserBadges.vue